/**
 * FlahaSOIL v2 — Soil physics summary chart adapter (Phase 10C-D).
 */
import type { WaterRetentionAnalysisBlock } from "@flaha/shared-types";
import type { ScientificChartData, ScientificChartStatus } from "../types/ScientificChartTypes";
import { CHART_UNITS } from "../utils/chartUnits";

export interface SoilPhysicsChartData {
  saturation: number;
  fieldCapacity: number;
  wiltingPoint: number;
  plantAvailableWater: number;
}

export function soilPhysicsChartAdapter(
  retention: WaterRetentionAnalysisBlock | null
): ScientificChartData<SoilPhysicsChartData | null> {
  let status: ScientificChartStatus = "READY";

  if (!retention) {
    status = "MISSING_DATA";
    return {
      status,
      title: "Soil Physics Water Summary",
      description: "Comparison of saturation, field capacity, wilting point, and plant available water.",
      data: null,
      warnings: [],
      units: { water: CHART_UNITS.volPercent },
      source: "Saxton-Rawls (2006)",
      accessibilitySummary: "No data available for soil physics water summary.",
    };
  }

  const data: SoilPhysicsChartData = {
    saturation: retention.saturation.waterContentVolPercent,
    fieldCapacity: retention.fieldCapacity.waterContentVolPercent,
    wiltingPoint: retention.wiltingPoint.waterContentVolPercent,
    plantAvailableWater: retention.plantAvailableWater,
  };

  return {
    status: "READY",
    title: "Soil Physics Water Summary",
    description: "Comparison of saturation, field capacity, wilting point, and plant available water.",
    data,
    warnings: [],
    units: { water: CHART_UNITS.volPercent },
    source: "Saxton-Rawls (2006)",
    accessibilitySummary: `Soil physics summary: Saturation at ${data.saturation.toFixed(1)}%, Field Capacity at ${data.fieldCapacity.toFixed(1)}%, Wilting Point at ${data.wiltingPoint.toFixed(1)}%. Plant Available Water is ${data.plantAvailableWater.toFixed(1)}%.`,
  };
}
